module.exports = __webpack_public_path__ + "static/media/rcm.9320a483.svg";